export default __webpack_public_path__ + "static/media/react_native_icon.2f2532db.png";